import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Dialog, DialogContent, DialogTitle, Paper, PaperProps } from '@material-ui/core';
import React from 'react';
import Draggable from 'react-draggable';
import styled, { css } from 'styled-components';

const DraggablePaper: React.FC<PaperProps> = (props) => {
  return (
    <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
};

type IProps = {
  onClose: () => void;
  title: string;
  width?: number;
  height: number;
  disableBackdropClick?: boolean;
};

export const ModalWrapper: React.FC<IProps> = (props) => {
  const handleClose = (event: {}, reason: 'backdropClick' | 'escapeKeyDown') => {
    if (props.disableBackdropClick && reason === 'backdropClick') {
      return;
    }
    props.onClose();
  };

  return (
    <Dialog maxWidth={'xl'} fullWidth={!props.width} open={true} onClose={handleClose} PaperComponent={DraggablePaper}>
      <DialogTitleStyled id="draggable-dialog-title">
        {props.title}
        <IconWrapper onClick={props.onClose}>
          <FontAwesomeIcon icon={faTimes} />
        </IconWrapper>
      </DialogTitleStyled>

      <DialogContentStyled width={props.width} height={props.height}>
        {props.children}
      </DialogContentStyled>
    </Dialog>
  );
};

const DialogTitleStyled = styled(DialogTitle)`
  cursor: move;
`;

export const IconWrapper = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
  display: inline-block;
  align-items: center;
  width: 24px;
  height: 24px;
  cursor: pointer;
  font-size: 20px;
`;

const DialogContentStyled = styled(DialogContent)<{ width?: number; height: number }>`
  ${(props) =>
    props.width &&
    css`
      width: ${props.width}px;
    `}
  height: ${(props) => props.height}px;
  display: flex;
  flex-direction: column;
`;
